if (!customElements.get('suzuplus-cart')) {
  class SuzuplusCart extends HTMLElement {
    constructor() {
      super();
      this.initListDog();
      this.initializeCartEventListeners();
      this.displayCartItems();
      this.addCartItem();
      this.displayCartLimit();
    }

    initListDog() {
      let subBuyBtn = document.querySelector('#sz-subscription-btn-buy');
      if (subBuyBtn) {
        const dogsku = subBuyBtn.getAttribute('data-sku');
        subBuyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.listDogs(dogsku);
        })
      }
    }

    listDogs(dogsku) {
      const customerEmail = window.customerEmail;
      let loading_bg = document.querySelector(".loading_bg");
      const apiMiddlewareUrl = window.middleware_api_url  + '/suzu/search-dogs';
      loading_bg.style.display = "block";
      fetch(apiMiddlewareUrl, {
        method: 'POST',
        body: JSON.stringify({ email: customerEmail, sub_skus: [dogsku] }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then((response) => response.json())
          .then((response) => {
            if (response.status === true) {
              this.displayDogs(response.data.dogs);
              popupOpen('popup_subscription_allocated');
              loading_bg.style.display = "none";
            } else {
              loading_bg.style.display = "none";
              showToast('Something went wrong! Please try again later.', 'error');
            }
          }).catch((err) => {
        console.error(err);
      });
    }

    displayDogs(dogs) {
      const self = this;
      const container = document.getElementById('dogsList');
      container.innerHTML = ''; // Clear the container first
      if (dogs.length > 0) {
        $('#popup_subscription_allocated').removeClass('nodogs');
        dogs.forEach(dog => {
          // Creating the HTML structure
          const dogItemHtml = `
            <div class="suzu-card-item" data-token="${dog.token}" data-id="${dog.id}" data-name="${dog.name}" data-level="${dog.level}" data-image="${dog.img}">
                <div class="suzu-card-item-info">
                    <div class="suzu-card-image">
                        <img src="${dog.img}" class="object-contain">
                    </div>
                    <div class="suzu-card-body">
                        <div class="suzu-card-content">
                            <h4 class="suzu-card-name">${dog.name}</h4>
                            <p class="suzu-card-level">Lv. ${dog.level}</p>
                        </div>
                        <p class="suzu-card-id">#${dog.id}</p>
                    </div>
                </div>
            </div>
        `;

          // Append the generated HTML to the container
          container.innerHTML += dogItemHtml;
        });
      } else {
        $('#popup_subscription_allocated').addClass('nodogs');
        const errorMessage = document.querySelector('#sz-subscription-btn-buy').getAttribute('data-error-msg');
        container.innerHTML = errorMessage;
      }


      // Attach click event to each dog card to toggle selection
      $('.suzu-card-item').click(function() {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        self.updateAddToCartButton();
      });
    }

    updateAddToCartButton() {
      var hasSelection = $('.suzu-card-item.active').length > 0;
      $('#sz-subscription-addtocart-btn').prop('disabled', !hasSelection);
    }

    displayCartItems() {
      // Get the cart items from localStorage
      var currentCurrencyRate = Shopify.currency.rate;
      let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
      let currentCustomerId = window.meta.page.customerId || '';
      let currentCart = cartItems.find(cart => cart.customer_id === currentCustomerId);

      // Get the container where the cart items will be displayed
      var container = this.querySelector('#cartItemsContainer');

      // Clear previous contents
      container.innerHTML = '';

      if (currentCart && currentCart.items.length > 0) {

        let totalAmount = 0; // Initialize total amount
        let totalQty = 0; // Initialize total qty

        // Iterate over each main item in the cart
        currentCart.items.forEach(mainItem => {
          // Create a container for this main item
          var mainItemContainer = document.createElement('div');
          var titleAllocatedDog = this.querySelector('#cartItemsContainer').getAttribute('data-allocated-dog');
          const priceNomal = mainItem.price_normal*currentCurrencyRate;
          const mainItemPrice = Shopify.formatMoney(priceNomal, "¥{{amount_no_decimals}}");
          mainItemContainer.classList.add('cart-suzu-item');
          mainItemContainer.setAttribute('data-sku', mainItem.sku);
          mainItemContainer.innerHTML = `
        <div class="cart-suzu-item-image"><img src="${mainItem.image}" alt="${mainItem.name}" style="width:100px; height:auto;"></div>
      `;
          var mainItemContent = document.createElement('div');
          mainItemContent.classList.add('cart-suzu-item-detail');
          mainItemContent.innerHTML = `
        <p class="card__vendor text-theme-light text-sm mb-2">AI AVATAR Pte. Ltd</p>
        <p class="cart-item__title m-0 font-bold text-current js-item-name">${mainItem.name}</p>
        <div class="cart-suzu-item-price"><strong class="price__current">${mainItemPrice}</strong></div>
        <div class="cart-suzu-allocated-title font-bold">${titleAllocatedDog}</div>
      `;

          // List to hold individual dog items
          var itemList = document.createElement('ul');
          itemList.classList.add('cart-suzu-dogs');

          // Iterate over the individual dogs in the main item
          mainItem.items.forEach((item, itemIndex) => {
            var itemElement = document.createElement('li');
            itemElement.innerHTML = `
                <div class="dog-item" data-id="${item.id}">
                    <div class="dog-item-image"> <img src="${item.image}" alt="${item.name}" style="width:70px; height:auto;"></div>
                    <div class="dog-item-detail">
                        <div class="suzu-card-content">
                            <p class="cart-item__title m-0 text-current js-item-name">${item.name}</p>
                            <p class="suzu-card-level">Lv. ${item.level}</p>
                        </div>
                        <p class="suzu-card-id">#${item.id}</p>
                    </div>
                    <div class="dog-item-qty cart-item__qty" data-sku-id="${item.id}_${mainItem.sku}">
                       <div class="flex items-center mt-4">
                        <quantity-input class="inline-block">
                          <div class="qty-input qty-input--combined inline-flex items-center">
                              <button type="button" class="qty-input__btn dog-item-qty-btn btn btn--minus no-js-hidden" name="minus">
                                  <span class="visually-hidden">-</span>
                              </button>
                              <input type="number"
                                     class="qty-input__input input"
                                     name="suzu-card-quantity-${item.id}"
                                     id="suzu-card-quantity-${item.id}"
                                     min="1"
                                     value="${item.quantity}">
                              <button type="button" class="qty-input__btn dog-item-qty-btn btn btn--plus no-js-hidden" name="plus">
                                  <span class="visually-hidden">+</span>
                              </button>
                          </div>
                       </quantity-input>
                       <a class="cart-item__remove btn btn--icon dog-item__remove" data-id="${item.id}" href="#" data-index="1" aria-label="Remove" data-no-instant="">
                              <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor"></path></svg>
                        </a>
                      </div>
                    </div>
                </div>
            `;
            itemList.appendChild(itemElement);
            const quantity = item.quantity;
            totalAmount += quantity * parseInt(priceNomal);
            totalQty += quantity;
          });

          // Append the list of individual items to the main item container
          mainItemContent.appendChild(itemList);
          mainItemContainer.appendChild(mainItemContent);

          // Append the main item container to the overall container
          container.appendChild(mainItemContainer);
        });

        this.querySelector(".cart-suzu-total-amount").innerText = Shopify.formatMoney(totalAmount, "¥{{amount_no_decimals}}");

        let suzuplusCount = document.querySelector('.suzuplus-count-item');

        // If the cart is empty, show a message
        if(currentCart.items.length === 0) {
          this.querySelector('#cart-suzuplus-form').classList.add('cart-suzuplus-empty');
          this.querySelector(".cart-suzu-total-amount").innerText = 0; // Reset total amount if cart is empty
          if(suzuplusCount) { suzuplusCount.innerText = ''; }
        } else {
          this.querySelector('#cart-suzuplus-form').classList.remove('cart-suzuplus-empty');
          if(suzuplusCount) { suzuplusCount.innerText = totalQty; }
        }
      } else {
        this.querySelector('#cart-suzuplus-form').classList.add('cart-suzuplus-empty');
        this.querySelector(".cart-suzu-total-amount").innerText = 0; // Reset total amount if cart is empty
        if(document.querySelector('.suzuplus-count-item')) { document.querySelector('.suzuplus-count-item').innerText = ''; }
      }
    }

    displayCartLimit() {

      const checkoutBtn = this.querySelector('.btn-checkout-suzu');
      if (checkoutBtn) {
        const maxLimitMessage = checkoutBtn.getAttribute('data-max-limit-message');
        var threshold = parseFloat(window.maximum_limit_price);
        checkoutBtn.addEventListener('click', (evt) => {
          evt.preventDefault();
          let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
          let currentCustomerId = window.meta.page.customerId || '';
          let currentCart = cartItems.find(cart => cart.customer_id === currentCustomerId);
          var currentCurrencyRate = Shopify.currency.rate;

          if (currentCart && currentCart.items.length > 0) {
            var totalAmount = 0; // Initialize total amount
            var totalQty = 0; // Initialize total qty
            // Iterate over each main item in the cart

            currentCart.items.forEach(mainItem => {
              const priceNomal = mainItem.price_normal*currentCurrencyRate;
              // Iterate over the individual dogs in the main item
              mainItem.items.forEach((item, itemIndex) => {
                const quantity = item.quantity;
                totalAmount += quantity * parseInt(priceNomal);
                totalQty += quantity;
              });
            });
          }

          const cartTotalInBaseCurrency = totalAmount / currentCurrencyRate;

          if (cartTotalInBaseCurrency > threshold) {
            showToast(maxLimitMessage, 'error');
          } else {
            window.location = `${Shopify.routes.root}pages/checkout-credit-card?type=plus`;
          }
        });
      }


    }

    initializeCartEventListeners() {
      const self = this;
      document.addEventListener('click', function(event) {
        const loader = document.querySelector('.cart-suzu-loader');
        const cartItemsContainer = document.getElementById('cartItemsContainer');

        if (event.target.matches('.dog-item-qty-btn')) {
          loader.hidden = false;
          cartItemsContainer.classList.add('pointer-events-none');
          const isPlusButton = event.target.name === 'plus';
          const itemElement = event.target.closest('.dog-item');
          const mainItemElement = event.target.closest('.cart-suzu-item');
          const itemId = itemElement.dataset.id;
          const sku = mainItemElement.dataset.sku;

          setTimeout(() => {
            self.updateCartItemQuantity(sku, itemId, isPlusButton ? 1 : -1);
            loader.hidden = true;
            cartItemsContainer.classList.remove('pointer-events-none');
          }, 500);
        }
        // Update item quantity when qty-input__input changes
        $('#cartItemsContainer .qty-input__input').on('change', function() {
          loader.hidden = false;
          const sku = $(this).closest('.cart-suzu-item').data('sku');
          const itemId = $(this).closest('.dog-item').data('id');
          const quantity = parseInt($(this).val());
          setTimeout(() => {
            self.updateCartItemQuantity(sku, itemId, quantity);
            loader.hidden = true;
            cartItemsContainer.classList.remove('pointer-events-none');
          }, 500);
          console.log(quantity);
        });

        // Remove item
        if (event.target.matches('.dog-item__remove') || event.target.closest('.dog-item__remove')) {
          loader.hidden = false;
          cartItemsContainer.classList.add('pointer-events-none');
          const itemElement = event.target.closest('.dog-item');
          const mainItemElement = event.target.closest('.cart-suzu-item');
          const itemId = itemElement.dataset.id;
          const sku = mainItemElement.dataset.sku;

          setTimeout(() => {
            self.removeCartItem(sku, itemId);
            loader.hidden = true;
            cartItemsContainer.classList.remove('pointer-events-none');
          }, 500);

        }
      });
    }

    updateCartItemQuantity(sku, itemId, change) {
      console.log(sku, itemId, change);
      // Fetch existing carts from localStorage, or initialize a new array
      let carts = JSON.parse(localStorage.getItem('cartItems')) || [];
      let currentCustomerId = window.meta.page.customerId || 'defaultCustomerId';
      var messageUpdateCart = this.querySelector('#cartItemsContainer').getAttribute('data-message-update-cart');

      // Find the current customer's cart
      let cartIndex = carts.findIndex(cart => cart.customer_id === currentCustomerId);
      if (cartIndex === -1) {
        console.log("No cart found for the current customer.");
        return; // Exit if no cart is found for the current customer
      }
      let cart = carts[cartIndex];
      // Find the main item within the cart
      let mainItemIndex = cart.items.findIndex(item => item.sku === sku);
      if (mainItemIndex === -1) {
        return; // Exit if the main item is not found in the cart
      }

      // Find the specific item to update its quantity
      let itemIndex = cart.items[mainItemIndex].items.findIndex(item => item.id == itemId); // Ensure item.id is treated as a string or number accordingly

      if (change > 1) {
        cart.items[mainItemIndex].items[itemIndex].quantity = change;

        localStorage.setItem('cartItems', JSON.stringify(carts));
        showToast(`${messageUpdateCart} ${cart.items[mainItemIndex].items[itemIndex].name}.`, 'success');
        this.displayCartItems();
      } else {
        if (itemIndex !== -1) {
          // Update item quantity, ensuring it doesn't go below 1
          cart.items[mainItemIndex].items[itemIndex].quantity = Math.max(1, cart.items[mainItemIndex].items[itemIndex].quantity + change);

          localStorage.setItem('cartItems', JSON.stringify(carts));
          showToast(`${messageUpdateCart} ${cart.items[mainItemIndex].items[itemIndex].name}.`, 'success');

          this.displayCartItems();
        }
      }
    }

    removeCartItem(sku, itemId) {
      // Fetch existing carts from localStorage, or initialize a new array if none exists
      let carts = JSON.parse(localStorage.getItem('cartItems')) || [];
      let currentCustomerId = window.meta.page.customerId || 'defaultCustomerId';
      var messageRemoveCart = this.querySelector('#cartItemsContainer').getAttribute('data-message-remove-cart');

      // Find the current customer's cart
      let cartIndex = carts.findIndex(cart => cart.customer_id === currentCustomerId);
      if (cartIndex === -1) {
        return;
      }
      let cart = carts[cartIndex];
      // Find the main item in the cart
      let mainItemIndex = cart.items.findIndex(item => item.sku === sku);
      if (mainItemIndex !== -1) {
        // Find the specific item to remove
        let itemIndex = cart.items[mainItemIndex].items.findIndex(item => item.id == itemId);
        if (itemIndex !== -1) {
          // Remove the item from the items array
          cart.items[mainItemIndex].items.splice(itemIndex, 1);

          // If the main item has no more items, remove the main item as well
          if (cart.items[mainItemIndex].items.length === 0) {
            cart.items.splice(mainItemIndex, 1);
          }

          // Update the carts array in localStorage with the updated cart
          localStorage.setItem('cartItems', JSON.stringify(carts));
          showToast(messageRemoveCart, 'success');

          this.displayCartItems();
        }
      }
    }

    addCartItem() {
      const self = this;
      var currentCurrencyRate = Shopify.currency.rate;
      $('#sz-subscription-addtocart-btn').click(function() {
        var quantity = parseInt($('#subscription-quantity').val());
        var sku = $('#sz-subscription-btn-buy').data('sku');
        var name = $('#sz-subscription-btn-buy').data('name');
        var price = $('#sz-subscription-btn-buy').data('price');
        var price_normal = $('#sz-subscription-btn-buy').data('price-normal');
        var productImage = $('#sz-subscription-btn-buy').data('product-image');
        var currentVariantId = $('#sz-subscription-btn-buy').data('current-variant-id');
        var messageSuccess = $(this).data('message-success');
        var customerId = window.meta.page.customerId || '';

        // Fetch existing cart from localStorage, or initialize a new one
        var carts = JSON.parse(localStorage.getItem('cartItems')) || [];
        // Find the cart for the current customer
        var cartIndex = carts.findIndex(cart => cart.customer_id === customerId);
        var currentCart;

        if(cartIndex === -1) {
          // If cart for current customer does not exist, create a new one
          currentCart = { customer_id: customerId, items: [] };
          carts.push(currentCart);
        } else {
          // If cart exists, use it
          currentCart = carts[cartIndex];
        }

        // Find the existing main item in the cart
        var mainItemIndex = currentCart.items.findIndex(item => item.sku === sku);

        // Selected dogs based on active class
        var selectedDogs = $('.suzu-card-item.active').map(function() {
          return {
            id: $(this).data('id'),
            name: $(this).data('name'),
            level: $(this).data('level'),
            image: $(this).data('image'),
            token: $(this).data('token'),
            quantity: quantity
          };
        }).get();

        if(mainItemIndex > -1) {
          // If main item exists, append new dogs or update quantities
          selectedDogs.forEach(dog => {
            var dogIndex = currentCart.items[mainItemIndex].items.findIndex(item => item.id === dog.id);
            if(dogIndex > -1) {
              currentCart.items[mainItemIndex].items[dogIndex].quantity += dog.quantity;
            } else {
              currentCart.items[mainItemIndex].items.push(dog);
            }
          });
        } else {
          // If main item does not exist, create a new one
          currentCart.items.push({
            sku: sku,
            name: name,
            image: productImage,
            price: Shopify.formatMoney(price_normal, "¥{{amount_no_decimals}}"),
            price_normal: price_normal,
            current_variant_id: currentVariantId,
            items: selectedDogs
          });
        }

        // Update the cart in localStorage
        localStorage.setItem('cartItems', JSON.stringify(carts));

        popupClose('popup_subscription_allocated');

        showToast(messageSuccess, 'success');
        $('#tab-suzu').click();
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
        // Refresh the cart display
        self.displayCartItems();

      });
    }

  }
  customElements.define('suzuplus-cart', SuzuplusCart);
}